








import { Component, Vue } from 'vue-property-decorator';
import ComponentA from '../components/ComponentA';

@Component({
  components: {
    ComponentA,
  },
})
export default class App extends Vue {
  show: boolean = false;

  exportStore(): void {
    console.log(this.$store.state);
    fetch('http://localhost:3000/info/checkout/12345');
  }
}
